import * as React from "react"
import { Navigate } from "react-router-dom"

import { REPORTS_ROUTES } from "@constants"
import AppLayout from "Layout"
import ReportsManagementPage from "./Management"


export const ReportsRoutes = {
    path: REPORTS_ROUTES.PATH,
    title: REPORTS_ROUTES.TITLE,
    accessKey: REPORTS_ROUTES.ACCESS_KEY,
    icon: 'briefcase',
    description: REPORTS_ROUTES.SUBTITLE,
    element: <AppLayout />,
    children: [{
        element: <Navigate to={REPORTS_ROUTES.MANAGE_PATH} replace />,  index: true
    }, {
        title: REPORTS_ROUTES.MANAGE_TITLE,
        path: REPORTS_ROUTES.MANAGE_PATH,
        dashboardKey: REPORTS_ROUTES.MANAGE_ID,
        element: <ReportsManagementPage />
    }]
}